import { render, staticRenderFns } from "./DialogH5.vue?vue&type=template&id=f4fb91f2&scoped=true&"
import script from "./DialogH5.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DialogH5.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DialogH5.vue?vue&type=style&index=0&id=f4fb91f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fb91f2",
  null
  
)

export default component.exports